import AppEvents from 'Shared/app-events';
import Api from 'Api/api-module';
class DocumentTypeFilter {
    constructor(filter, property) {
        this.#filter = filter;
        this.#property = property;
    }

    #filter;
    #property;

    name = ko.pureComputed(() => {
        var selected = new Array();
        console.debug(this.#filter);
        console.debug(res[this.#property]);
        if (this.#filter.Orders()) {
            selected.push(res["Orders"]);
        }
        if (this.#filter.Offers()) {
            selected.push(res["Offers"]);
        }
        if (this.#filter.CreditNotes()) {
            selected.push(res["CreditNotes"]);
        }
        if (this.#filter.Returns()) {
            selected.push(res["Returns"]);
        }

        return `${res[this.#property]}:  ${selected.join(', ')}`;
    });

    apply = (data) => {
        if (this.#filter.Orders()) {
            data["Orders"] = this.#filter.Orders();
        }
        if (this.#filter.Offers()) {
            data["Offers"] = this.#filter.Offers();
        }
        if (this.#filter.CreditNotes()) {
            data["CreditNotes"] = this.#filter.CreditNotes();
        }
        if (this.#filter.Returns()) {
            data["Returns"] = this.#filter.Returns();
        }
    }

    active = ko.pureComputed(() => this.#filter.Orders() || this.#filter.Offers() || this.#filter.CreditNotes() || this.#filter.Returns());

    remove = () => {
        this.#filter.Orders(false);
        this.#filter.Offers(false);
        this.#filter.CreditNotes(false);
        this.#filter.Returns(false);
    }
}

class StateFilter {
    constructor(filter, property) {
        this.#filter = filter;
        this.#property = property;
    }

    #filter;
    #property;

    name = ko.pureComputed(() => {
        const value = this.#filter[this.#property]();
        return `${res[this.#property]}:  ${res[`State_${value}`]}`;
    });

    apply = (data) => data[this.#property] = this.#filter[this.#property]();

    active = ko.pureComputed(() => this.#filter[this.#property]() != '');

    remove = () => this.#filter[this.#property]('');
}

class PeriodFilter {
    constructor(filter, property) {
        this.#filter = filter;
        this.#property = property;
    }

    #filter;
    #property;

    name = ko.pureComputed(() => {
        const value = this.#filter[this.#property]();
        return `${res[this.#property]}:  ${res[`Period_${value}`]}`;
    });

    apply = (data) => data[this.#property] = +this.#filter[this.#property]();

    active = ko.pureComputed(() => this.#filter[this.#property]());

    remove = () => this.#filter[this.#property](null);
}

class CheckboxFilter {
    constructor(filter, property) {
        this.#filter = filter;
        this.#property = property;
    }

    #filter;
    #property;

    name = ko.pureComputed(() => `${res[this.#property]}`);

    apply = (data) => data[this.#property] = this.#filter[this.#property]();

    active = ko.pureComputed(() => this.#filter[this.#property]());

    remove = () => this.#filter[this.#property](null);
}

class PropertyFilter {
    constructor(filter, property) {
        this.#filter = filter;
        this.#property = property;
    }

    #filter;
    #property;

    name = ko.pureComputed(() => `${res[this.#property]}:  ${this.#filter[this.#property]()}`);

    apply = (data) => data[this.#property] = this.#filter[this.#property]();

    active = ko.pureComputed(() => this.#filter[this.#property]());

    remove = () => this.#filter[this.#property](null);
}

class DateFilter {
    constructor(filter, property) {
        this.#filter = filter;
        this.#property = property;
    }

    #filter;
    #property;

    name = ko.pureComputed(() => `${res[this.#property]}:  ${new Date(this.#filter[this.#property]()).toLocaleDateString()}`);

    apply = (data) => data[this.#property] = this.#filter[this.#property]();

    active = ko.pureComputed(() => {
        var s = this.#filter[this.#property]();
        if (!s) return false;

        return s;
    });

    remove = () => this.#filter[this.#property](null);
}

export class FilterModel {
    constructor(data) {
        ko.mapping.fromJS(data, {}, this);

        this.filters.push(new DocumentTypeFilter(this, "DocumentTypes"));
        this.filters.push(new StateFilter(this, "State"));
        this.filters.push(new PeriodFilter(this, "Period"));
        this.filters.push(new PropertyFilter(this, "Query"));
        this.filters.push(new CheckboxFilter(this, "BacklogItems"));
        this.filters.push(new CheckboxFilter(this, "PurchaseItems"));
        this.filters.push(new CheckboxFilter(this, "ReleaseableItems"));
        this.filters.push(new DateFilter(this, "DateFrom"));
        this.filters.push(new DateFilter(this, "DateTo"));
        this.filters.push(new PropertyFilter(this, "ProjectId"));
        this.filters.push(new PropertyFilter(this, "ArticleId"));
        this.filters.push(new PropertyFilter(this, "ArticleName"));
        this.filters.push(new PropertyFilter(this, "BatchId"));
        this.filters.push(new PropertyFilter(this, "BudgetId"));
        this.filters.push(new PropertyFilter(this, "Code1"));
        this.filters.push(new PropertyFilter(this, "Code2"));
        this.filters.push(new PropertyFilter(this, "Code3"));
        this.filters.push(new PropertyFilter(this, "DocumentId"));
        this.filters.push(new PropertyFilter(this, "OrderText"));
        this.filters.push(new PropertyFilter(this, "Ean"));
        this.filters.push(new PropertyFilter(this, "Gtin"));
        this.filters.push(new PropertyFilter(this, "ManufacturerProductId"));
        this.filters.push(new PropertyFilter(this, "SerialNumber"));
        this.filters.push(new PropertyFilter(this, "UniformNumber"));
    }

    filters = ko.observableArray([]);

    activeFilters = ko.pureComputed(() => this.filters().filter(x => x.active()));

    hasActiveFilters = ko.pureComputed(() => this.activeFilters().length);

    clearAll = () => {
        this.activeFilters().forEach(x => x.remove());

        AppEvents.emit("activity.filter-changed");
    }
}

class ActivityItemDetailModel {


}

class OfferDetailModel extends ActivityItemDetailModel {
    constructor(data, offer) {
        super();
        this.offer = offer;

        ko.mapping.fromJS(data, this.mapping, this);
    }

    mapping = {
        observe: [""]
    };

    name = ko.pureComputed(() => {
        if (this.IsVariousArticle)
            return this.ItemName;

        if (this.LanguageId !== 1) {
            return this.CArticleName ? this.CArticleName : this.ArticleName;
        }

        return this.ItemName;
    });

    statusCss = ko.pureComputed(() => {
        if (this.offer.Expired) {
            return "bg-soft-dark text-dark";
        }

        switch (this.OfferState) {
            case 0:
                return "bg-soft-primary text-primary";
            case 1:
            case 2:
                return "bg-soft-dark text-dark";
            case 3:
                return "bg-soft-danger text-danger";
            case 4:
                return "bg-soft-warning text-warning";
            default:
                return "";
        }
    });
}

class OrderDetailModel extends ActivityItemDetailModel {
    constructor(data) {
        super();
        ko.mapping.fromJS(data, this.mapping, this);
    }

    mapping = {
        observe: [""]
    };

    name = ko.pureComputed(() => {
        if (this.IsVariousArticle)
            return this.ItemName;

        if (this.LanguageId !== 1) {
            return this.CArticleName ? this.CArticleName : this.ArticleName;
        }

        return this.ItemName;
    });

    statusCss = ko.pureComputed(() => {
        if (this.IsDeliveryBlocked) {
            return "bg-soft-warning text-warning";
        }

        switch (this.State) {
            case 1:
            case 2:
            case 3:
            case 4:
                return "bg-soft-success text-success";
            case 5:
                return "bg-soft-dark text-dark";
            case 6:
                return "bg-soft-danger text-danger";
            default:
                return "";
                break;
        }
    });
}

class CreditNoteDetailModel extends ActivityItemDetailModel {
    constructor(data) {
        super();
        ko.mapping.fromJS(data, this.mapping, this);
    }

    mapping = {
        observe: [""]
    };

    name = ko.pureComputed(() => {
        if (this.IsVariousArticle)
            return this.ItemName;

        if (this.LanguageId !== 1) {
            return this.CArticleName ? this.CArticleName : this.ArticleName;
        }

        return this.ItemName;
    });

    statusCss = ko.pureComputed(() => {
        switch (this.State) {
            case 1:
                return "bg-soft-primary text-primary";
                break;
            case 2:
                return "bg-soft-secondary text-secondary";
                break;
            case 3:
            case 4:
            case 5:
                return "bg-soft-dark text-dark";
                break;
            case 6:
                return "bg-soft-danger text-danger";
                break;
            default:
                return "";
                break;
        }
    });
}

class ReturnDetailModel extends ActivityItemDetailModel {
    constructor(data) {
        super();
        ko.mapping.fromJS(data, this.mapping, this);
    }

    mapping = {
        observe: [""]
    };

    name = ko.pureComputed(() => {
        if (this.IsVariousArticle)
            return this.ItemName;

        if (this.LanguageId !== 1) {
            return this.CArticleName ? this.CArticleName : this.ArticleName;
        }

        return this.ItemName;
    });

    statusCss = ko.pureComputed(() => {
        switch (this.ItemState) {
            case 1:
                return "bg-soft-info text-info";
                break;
            case 2:
                return "bg-soft-success text-success";
                break;
            case 3:
                return "bg-soft-warning text-warning";
                break;
            case 4:
                return "bg-soft-success text-success";
                break
            case 5:
                return "bg-soft-success text-success";
                break
            case 6:
                return "bg-soft-dark text-dark";
                break
            default:
                return "";
                break;
        }
    });
}

export default class ActivityItemModel {

    loaded = ko.observable(false);

    date = ko.pureComputed(() => new Date(parseInt(this.Date.substr(6))));
    year = ko.pureComputed(() => this.date().getFullYear());
    month = ko.pureComputed(() => this.date().getMonth());

    hasMore = ko.pureComputed(() => this.DetailCount > this.Details().length);

    update = (data) => {
        ko.mapping.fromJS(data, this);

        this.loaded(true);
    }
}

export class OrderModel extends ActivityItemModel {
    constructor(data, view) {
        super(view);

        ko.mapping.fromJS(data, this.mapping, this);
    }

    mapping = {
        observe: ["Details", "OrderState"],
        Details: {
            key: data => data.FixedItemId,
            create: options => {
                return new OrderDetailModel(options.data);
            }
        }
    }

    type = "order";
    loader = Api.nvApi.order;
    OrderState = ko.observable();


    statusCss = ko.pureComputed(() => {
        switch (this.OrderState()) {
            case 1:
                return "bg-soft-info text-info";
            case 2:
                return "bg-soft-success text-success";
            case 3:
            case 4:
            case 5:
                return "bg-soft-dark text-dark";
            case 16:
                return "bg-soft-danger text-danger";
            default:
                return "";
        }
    });
}

export class OfferModel extends ActivityItemModel {
    constructor(data, view) {
        super(view);
        ko.mapping.fromJS(data, this.mapping, this);
    }

    mapping = {
        observe: ["Details", "OfferState"],
        Details: {
            key: data => data.FixedItemId,
            create: options => new OfferDetailModel(options.data, this)
        }
    };

    type = "offer";
    loader = Api.nvApi.offer;
    OfferState = ko.observable();

    statusCss = ko.pureComputed(() => {
        switch (this.OfferState) {
            case 1:
                if (this.ValidDays <= 3) {
                    return "bg-soft-danger text-warning";
                }

                return "bg-soft-info text-info";
            case 2:
                return "bg-soft-danger text-danger";
            default:
                return "bg-soft-dark text-dark";
        }
    });
}

export class CreditNoteModel extends ActivityItemModel {
    constructor(data, view) {
        super(view);
        ko.mapping.fromJS(data, this.mapping, this);
    }

    mapping = {
        observe: ["Details", "OrderState", "StatusText"],
        Details: {
            key: data => data.FixedItemId,
            create: options => {
                return new CreditNoteDetailModel(options.data);
            }
        }
    }

    type = "creditnote";
    loader = Api.nvApi.creditNote;
    OrderState = ko.observable();

    statusCss = ko.pureComputed(() => {
        switch (this.OrderState()) {
            case 1:
            case 2:
                return "bg-soft-success text-success";
            case 3:
            case 4:
            case 5:
                return "bg-soft-dark text-dark";
            case 16:
                return "bg-soft-danger text-danger";
            default:
                return "";
        }
    });
}

export class ReturnModel extends ActivityItemModel {
    constructor(data, view) {
        super(view);
        ko.mapping.fromJS(data, this.mapping, this);
    }

    mapping = {
        observe: ["Details", "OrderState", "StatusText"],
        Details: {
            key: data => data.FixedItemId,
            create: options => {
                return new ReturnDetailModel(options.data);
            }
        }
    }

    type = "return";
    loader = Api.nvApi.return;

    statusCss = ko.pureComputed(() => {
        switch (this.State) {
            case 1:
                return "bg-soft-success text-success";
                break;
            case 2:
                return "bg-soft-secondary text-secondary";
                break;
            case 3:
                return "bg-soft-dark text-dark";
                break;
            default:
                return "";
                break;
        }
    });
}